<template>
  <div class="work-time-page">
    <Button type="primary" icon="plus-round" v-if="permissions === true && check === true" @click="edit(0)">{{$t("system.workTime.New_workTime")}}</Button>
    <Button type="primary" icon="plus-round" v-if="permissions !== true || check !== true" @click="edit(0)" disabled>{{$t("system.workTime.New_workTime")}}</Button>
    <el-table class="work-time-table" highlight-row stripe border :data="datas">
      <el-table-column type="index" :label="$t('system.workTime.index')" width="65px"></el-table-column>
      <el-table-column prop="name" :label="$t('system.workTime.name')"></el-table-column>
      <el-table-column prop="startTime" :label="$t('system.workTime.startTime')"></el-table-column>
      <el-table-column prop="endTime" :label="$t('system.workTime.endTime')"></el-table-column>
      <el-table-column :label="$t('system.workTime.operating')" width="150px">
        <template slot-scope="scope" >
          <el-button v-if="permissions === true" @click.native="edit(scope.row.id)" type="primary" size="small">{{$t('system.workTime.edit')}}</el-button>
          <el-button v-if="permissions === true" @click.native="remove(scope.row.id, scope.$index)" type="danger" size="small">{{$t('system.workTime.delete')}}</el-button>
          <el-button v-if="permissions !== true" type="primary" size="small" disabled>{{$t('system.workTime.edit')}}</el-button>
          <el-button v-if="permissions !== true" type="danger" size="small" disabled>{{$t('system.workTime.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <Table class="work-time-table" highlight-row stripe border :columns="columns" :data="datas"></Table> -->
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'workTime',
  data () {
    return {
      // columns: [
      //   { type: 'index', title: this.$t('system.workTime.index') },
      //   { title: this.$t('system.workTime.name'), key: 'name' },
      //   { title: this.$t('system.workTime.startTime'), key: 'startTime' },
      //   { title: this.$t('system.workTime.endTime'), key: 'endTime' },
      //   {
      //     title: this.$t('system.workTime.operating'),
      //     key: 'action',
      //     render: (h, params) => {
      //       if (this.permissions === true) {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small'
      //             },
      //             style: {
      //               marginRight: '5px'
      //             },
      //             on: {
      //               click: () => {
      //                 this.edit(params.index)
      //               }
      //             }
      //           }, this.$t('system.workTime.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small'
      //             },
      //             on: {
      //               click: () => {
      //                 if (confirm(this.$t('system.workTime.delete_message'))) {
      //                   this.remove(params.index)
      //                 }
      //               }
      //             }
      //           }, this.$t('system.workTime.delete'))
      //         ])
      //       } else {
      //         return h('div', [
      //           h('Button', {
      //             props: {
      //               type: 'primary',
      //               size: 'small',
      //               disabled: true
      //             },
      //             style: {
      //               marginRight: '5px'
      //             }
      //           }, this.$t('system.workTime.edit')),
      //           h('Button', {
      //             props: {
      //               type: 'error',
      //               size: 'small',
      //               disabled: true
      //             }
      //           }, this.$t('system.workTime.delete'))
      //         ])
      //       }
      //     }
      //   }
      // ],
      datas: [],
      check: true,
      permissions: false
    }
  },
  methods: {
    edit (id) {
      // id === -1 ? 0 : id
      this.$router.push({ name: 'WorkTimeEdit', params: { id } })
    },
    remove (id, index) {
      if (confirm(this.$t('system.workTime.delete_message'))) {
        this.$api.workTime.delete(id).then(() => {
          this.datas.splice(index, 1)
          if (this.datas.length < 3) {
            console.log('check')
            this.check = true
          }
        })
      }
    }
  },
  mounted () {
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.workTime.list().then(res => {
      next(vm => {
        vm.datas = res.workTimes
        if (vm.datas.length >= 3) {
          vm.check = false
        }
      })
    })
  }
}
</script>
<style scoped>
  .work-time-page {
    padding: 10px;
  }

  .work-time-table {
    margin-top: 20px;
  }
</style>





// WEBPACK FOOTER //
// List.vue?6ece3248